"use client";
import React, { useEffect, useState } from "react";
import "@/src/components/Home/LandingV6/landing-v6.css";
import { Nav, StartWritingButton } from "@/src/components/Home/LandingV6/ui";
import { Footer } from "@/src/components/Home/LandingV6/blocks";
import { CornerPin, Squiggle, Ribbon } from "@/src/components/Home/LandingV6/ornaments";

export default function ComparisonView({ data }) {
  const [theme, setTheme] = useState("paper");
  useEffect(() => {
    try {
      const s = window.localStorage.getItem("qv6-theme");
      if (s === "paper" || s === "midnight") setTheme(s);
    } catch (_) {}
  }, []);

  return (
    <div className={`qv6 ${theme === "midnight" ? "theme-midnight" : ""}`}>
      <Nav />

      <section className="qv6-comparison-hero" style={{ padding: "80px 40px 50px", textAlign: "center" }}>
        <div style={{ maxWidth: 880, margin: "0 auto" }}>
          <CornerPin color={data.accent}>quarkle vs. {data.name.toLowerCase()}</CornerPin>
          <h1
            className="tanker"
            style={{ fontSize: "clamp(48px, 7.5vw, 116px)", lineHeight: 0.92, letterSpacing: "-0.035em", margin: "16px 0 18px" }}
          >
            quarkle vs. <span className="display" style={{ fontStyle: "italic", color: data.accent }}>{data.name}</span>
          </h1>
          <p className="mono" style={{ fontSize: 12, letterSpacing: "0.1em", textTransform: "uppercase", opacity: 0.6, marginBottom: 14 }}>
            {data.dek}
          </p>
          <p className="display" style={{ fontSize: 19, fontStyle: "italic", opacity: 0.85, lineHeight: 1.55, maxWidth: 720, margin: "0 auto" }}>
            {data.summary}
          </p>
        </div>
      </section>

      <section style={{ padding: "20px 40px 90px" }}>
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <span className="caps" style={{ color: data.accent }}>the breakdown</span>
          <h2 className="tanker" style={{ fontSize: "clamp(32px, 4vw, 56px)", margin: "8px 0 0", lineHeight: 1 }}>
            what to actually <span className="display" style={{ fontStyle: "italic", color: data.accent }}>weigh</span>.
          </h2>
        </div>
        <div
          className="qv6-comparison-table-wrap"
          style={{ maxWidth: 980, margin: "0 auto", "--comparison-accent": data.accent }}
        >
          <table className="qv6-comparison-table">
            <thead>
              <tr>
                <th scope="col">what to weigh</th>
                <th scope="col">{data.name}</th>
                <th scope="col">Quarkle</th>
              </tr>
            </thead>
            <tbody>
              {data.rows.map(([label, a, b]) => (
                <tr key={label}>
                  <th scope="row">{label}</th>
                  <td data-label={data.name}>{a}</td>
                  <td data-label="Quarkle" className="qv6-comparison-quarkle">{b}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section style={{ padding: "70px 40px", background: "var(--paper-2)", borderTop: "1.5px solid var(--ink)", borderBottom: "1.5px solid var(--ink)" }}>
        <div style={{ maxWidth: 1080, margin: "0 auto" }}>
          <div
            style={{
              background: "var(--paper-3)",
              border: `1.5px solid ${data.accent}`,
              borderRadius: 12,
              padding: "22px 26px",
            }}
          >
            <span className="caps" style={{ color: data.accent }}>the honest take · them vs. us</span>
            <Squiggle w={90} h={8} color={data.accent} />
            <div className="qv6-honest-take-grid">
              <div>
                <span className="mono qv6-honest-take-label">{data.name}</span>
                <p className="display">{data.honestTake.competitor}</p>
              </div>
              <div className="qv6-honest-take-quarkle">
                <span className="mono qv6-honest-take-label">Quarkle</span>
                <p className="display">{data.honestTake.quarkle}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: "80px 40px", textAlign: "center" }}>
        <Ribbon color="var(--pink)" rotate={-2}>try Quarkle on your own pages</Ribbon>
        <h2 className="tanker" style={{ fontSize: "clamp(40px, 5vw, 80px)", margin: "18px 0 20px", lineHeight: 0.95 }}>
          try it on your own <span className="display" style={{ fontStyle: "italic", color: "var(--pink)" }}>chapter one</span>.
        </h2>
        <StartWritingButton variant="pink" size="xl">start writing →</StartWritingButton>

      </section>

      <Footer />
    </div>
  );
}
